import { render, staticRenderFns } from "./InventoryItemMasterFormV2.vue?vue&type=template&id=0c6f378a&scoped=true&"
import script from "./InventoryItemMasterFormV2.vue?vue&type=script&lang=js&"
export * from "./InventoryItemMasterFormV2.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItemMasterFormV2.vue?vue&type=style&index=0&id=0c6f378a&scoped=true&lang=css&"
import style1 from "./InventoryItemMasterFormV2.vue?vue&type=style&index=1&id=0c6f378a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f378a",
  null
  
)

export default component.exports